import React from "react";
import Icon from "./Icon";
import Color from "../../styles/Color";

export const TimeIcon = ({ className, size }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 48 48">
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#838c99"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
    >
      <circle cx="34" cy="34.002" r="12" />
      <path d="M38 34.002h-4v-6M18 36H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v13M10 .002v10M30 .002v10M0 14.002h40" />
    </g>
  </svg>
);

export const DateIconNew = ({ size, color = "#3e5fc2" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <g>
      <path
        d="M17,12H12v5h5ZM16,1V3H8V1H6V3H5A1.991,1.991,0,0,0,3.01,5L3,19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5a2.006,2.006,0,0,0-2-2H18V1Zm3,18H5V8H19Z"
        fill={color}
        opacity="0.87"
      />
    </g>
  </svg>
);

export const TimeIconNew = ({ size, color = "#3e5fc2" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <g>
      <path
        d="M11.99,2A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
        fill={color}
      />
      <path d="M12.5,7H11v6l5.25,3.15L17,14.92l-4.5-2.67Z" fill={color} />
    </g>
  </svg>
);

export const LocationIcon = ({ size, color = "#3e5fc2" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      fill={color}
    />
  </svg>
);

export const CloudIcon = ({ size, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 512 512">
    <g>
      <path d="M432.3,233.3c55.1,12.6,89.7,67.5,77.1,122.6c-10.6,46.5-51.9,79.5-99.6,79.7H128.1C57.4,435.7,0.1,378.4,0,307.7   c-0.1-60.9,42.8-113.5,102.5-125.6v-2.6c-0.1-42.4,34.3-76.8,76.7-76.9c13.7,0,27.2,3.6,39,10.6c50.1-49.5,130.8-49,180.3,1.1   c23.9,24.2,37.1,56.9,36.8,90.8C435.4,214.9,434.4,224.1,432.3,233.3z M281.8,282h76.8L256.2,179.5L153.7,282h76.8v76.8h51.2V282z" />
    </g>
  </svg>
);

export const DownloadIcon = ({ size, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24">
    <g>
      <rect x={4} y={18} width={16} height={2} rx={1} ry={1} />
      <rect
        x={3}
        y={17}
        width={4}
        height={2}
        rx={1}
        ry={1}
        transform="rotate(-90 5 18)"
      />
      <rect
        x={17}
        y={17}
        width={4}
        height={2}
        rx={1}
        ry={1}
        transform="rotate(-90 19 18)"
      />
      <path d="M12 15a1 1 0 01-.58-.18l-4-2.82a1 1 0 01-.24-1.39 1 1 0 011.4-.24L12 12.76l3.4-2.56a1 1 0 011.2 1.6l-4 3a1 1 0 01-.6.2z" />
      <path d="M12 13a1 1 0 01-1-1V4a1 1 0 012 0v8a1 1 0 01-1 1z" />
    </g>
  </svg>
);

export const UndoIcon = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      fill={color}
      d="M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z"
    />
  </svg>
);

export const DocumentIcon = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
);

export const GroupIcon = ({ size, color, title }) => (
  <svg
    enableBackground="new 0 0 24 24"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
  >
    {title && <title>{title}</title>}
    <g>
      <path d="M12,12.75c1.63,0,3.07,0.39,4.24,0.9c1.08,0.48,1.76,1.56,1.76,2.73L18,18H6l0-1.61c0-1.18,0.68-2.26,1.76-2.73 C8.93,13.14,10.37,12.75,12,12.75z M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1 C4.76,14.04,4.39,14,4,14c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85 C21.93,14.21,20.99,14,20,14c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M12,6c1.66,0,3,1.34,3,3 c0,1.66-1.34,3-3,3s-3-1.34-3-3C9,7.34,10.34,6,12,6z" />
    </g>
  </svg>
);

export const EmailIcon = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

export const BookingIcon = ({ size, color }) => (
  <svg
    enableBackground="new 0 0 24 24"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
  >
    <g>
      <path d="M17,1H7C5.9,1,5,1.9,5,3v18c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V3C19,1.9,18.1,1,17,1z M7,18V6h10v12H7z M16,11V9.14 C16,8.51,15.55,8,15,8H9C8.45,8,8,8.51,8,9.14l0,1.96c0.55,0,1,0.45,1,1c0,0.55-0.45,1-1,1l0,1.76C8,15.49,8.45,16,9,16h6 c0.55,0,1-0.51,1-1.14V13c-0.55,0-1-0.45-1-1C15,11.45,15.45,11,16,11z M12.5,14.5h-1v-1h1V14.5z M12.5,12.5h-1v-1h1V12.5z M12.5,10.5h-1v-1h1V10.5z" />
    </g>
  </svg>
);

export const SettingsIcon = ({ size, color }) => (
  <svg
    enableBackground="new 0 0 24 24"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
  >
    <g>
      <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
    </g>
  </svg>
);

export const OfficeIcon = ({ size, color, title }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill={color}>
    {title && <title>{title}</title>}
    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
  </svg>
);

export const ThreeDots = ({ size, color = "#3e5fc2" }) => (
  <svg
    id="Group_268"
    data-name="Group 268"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path id="Path_117" data-name="Path 117" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_118"
      data-name="Path 118"
      d="M12,8a2,2,0,1,0-2-2A2.006,2.006,0,0,0,12,8Zm0,2a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Zm0,6a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,16Z"
      fill={color}
    />
  </svg>
);

export const BackButton = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 16 16">
    <path
      id="Path_81"
      data-name="Path 81"
      d="M20,11H7.83l5.59-5.59L12,4,4,12l8,8,1.41-1.41L7.83,13H20Z"
      transform="translate(-4 -4)"
      fill={color}
    />
  </svg>
);

export const Arrow = ({ size, direction, viewBox, color }) => {
  let arrowDirection = "unset";
  switch (direction) {
    case "top":
      arrowDirection = "rotate(90deg)";
      break;
    case "right":
      arrowDirection = "rotate(180deg)";
      break;
    case "down":
      arrowDirection = "rotate(270deg)";
      break;
    default:
      break;
  }
  return (
    <svg
      width={size}
      height={size}
      style={{ transform: arrowDirection }}
      viewBox={viewBox ? viewBox : "0 0 24 24"}
      fill={color ? color : "auto"}
    >
      <path
        id="Path_145"
        data-name="Path 145"
        d="M13,7.41,8.41,12,13,16.59,11.59,18l-6-6,6-6Z"
      />
    </svg>
  );
};

export const DoubleArrow = ({ size, direction, color }) => {
  let arrowDirection = "unset";
  switch (direction) {
    case "top":
      arrowDirection = "rotate(90deg)";
      break;
    case "right":
      arrowDirection = "rotate(180deg)";
      break;
    case "down":
      arrowDirection = "rotate(270deg)";
      break;
    default:
      break;
  }
  return (
    <svg
      width={size}
      height={size}
      style={{ transform: arrowDirection }}
      viewBox="0 0 24 24"
      fill={color ? color : "auto"}
    >
      <path
        id="Path_146"
        data-name="Path 146"
        d="M18,7.41,13.41,12,18,16.59,16.59,18l-6-6,6-6ZM7.59,6h-2V18h2Z"
      />
    </svg>
  );
};

export const BankIDIcon = () => (
  <svg width="24" height="22" viewBox="0 0 169 158">
    <g>
      <path
        d="M45.916 135.23c5.268 0 9.905 2.083 9.015 7.63l-1.005 6.257c-.355 2.211-.289 2.873 2.253 2.922l-2.583 5.878c-4.495.291-6.67-.167-7.75-2.046-2.384 1.422-5.006 2.129-7.814 2.129-5.093 0-6.845-2.541-6.392-5.378.213-1.34 1.03-2.67 2.328-3.756 2.794-2.336 9.715-2.673 12.42-4.462.236-2.002-.6-2.712-3.15-2.712-2.979 0-5.466.961-9.714 3.754l1.035-6.47c3.698-2.58 7.251-3.747 11.357-3.747zm32.032 0c4.892 0 7.172 3.008 6.407 7.968L82.075 158h-8.773l1.889-12.256c.342-2.244-.3-3.266-2.028-3.266-1.392 0-2.649.764-3.872 2.414L67.27 158H58.5l3.446-22.395h8.774l-.452 2.929c2.772-2.376 4.896-3.305 7.68-3.305zm22.058-7.436l-2.19 14.881 8.377-8.065H117l-10.759 9.971L114.866 158h-10.973l-6.656-10.808h-.082L95.567 158H86.82l4.438-30.206h8.747zm-78.437.93c7.265 0 9.048 3.578 8.525 6.855-.423 2.664-2.276 4.617-5.514 5.906 4.08 1.496 5.669 3.863 5.084 7.52-.733 4.616-4.87 8.066-10.257 8.066H0l4.514-28.347h17.055zm131.362 0c11.337 0 14.611 7.98 13.563 14.547-1.03 6.442-6.288 13.8-16.25 13.8h-16.53l4.532-28.347h14.685zm-19.681 0l-4.553 28.347h-10.304l4.554-28.347h10.303zm-87.452 19.348c-2.392 1.462-6.8 1.21-7.281 4.213-.228 1.42.685 2.46 2.151 2.46 1.427 0 3.164-.583 4.517-1.5-.091-.498-.047-1.042.113-2.043l.5-3.13zm-30.297-3.262h-3.332l-1.265 7.938h3.076c3.421 0 5.43-1.33 5.872-4.115.38-2.37-1.017-3.823-4.351-3.823zm134.677-9.357h-2.75l-2.379 14.884h2.707c4.978 0 7.721-2.37 8.535-7.439.595-3.741-.573-7.445-6.113-7.445zm-133.187-2.41h-2.95l-1.185 7.44h2.95c3.334 0 4.889-1.704 5.212-3.74.344-2.158-.692-3.7-4.027-3.7zM43.87 14.405c3.239 0 5.74.667 7.04 1.88.907.849 1.245 1.96.977 3.219-.26 1.215-1.64 2.797-3.71 4.223-5.866 4.066-4.85 8.28-4.397 9.477 1.358 3.601 5.892 5.544 9.462 5.544h7.58l-7.07 43.956h.121c-2.632 16.426-4.59 28.813-4.953 31.148H6.964c.804-5.165 11.305-70.804 11.97-75.091h.645l2.179.005h.502l1.696.004.446.001.62.001h.371l.172.001.451.001h.504l.058.001h.076c5.043-.027 9.69-2.3 11.844-5.793 2.106-3.388 1.305-7.02-2.076-9.482-1.127-.818-2.424-2.145-2.17-3.787.348-2.217 4.171-5.308 9.617-5.308zM109.119 0c38.623 0 65.555 16.776 58.858 58.635-5.415 33.793-32.973 55.218-66.709 55.218H93.27l5.425-34.104c13.664-.152 25.113-6.51 27.478-21.265 2.54-15.881-5.526-22.699-20.537-22.815.003-.024.003-.037.003-.037h-11.04c-2.542 0-5.808-1.395-6.655-3.641-.264-.696-.802-3.206 3.314-6.068 1.58-1.101 4.324-3.347 4.9-6.034.471-2.252-.198-4.429-1.845-5.967-1.876-1.757-5.01-2.69-9.061-2.69-6.765 0-11.939 4.042-12.527 7.813-.037.245-.061.532-.061.846 0 1.5.59 3.709 3.397 5.763 1.03.753 2.028 1.86 2.028 3.341 0 .679-.21 1.43-.723 2.267-1.608 2.612-5.341 4.378-9.301 4.4l-7.243-.017L66.526 0z"
        transform="translate(-100 -239) translate(100 239)"
      />
    </g>
  </svg>
);

export const PrinterIcon = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 20 18">
    <path
      id="Path_115"
      data-name="Path 115"
      d="M19,8H5a3,3,0,0,0-3,3v6H6v4H18V17h4V11A3,3,0,0,0,19,8ZM16,19H8V14h8Zm3-7a1,1,0,1,1,1-1A1,1,0,0,1,19,12ZM18,3H6V7H18Z"
      transform="translate(-2 -3)"
      fill={color}
    />
  </svg>
);

export const DownloadIcon2 = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 14 17">
    <path
      id="Path_116"
      data-name="Path 116"
      d="M19,9H15V3H9V9H5l7,7ZM5,18v2H19V18Z"
      transform="translate(-5 -3)"
      fill={color}
    />
  </svg>
);

export const MessageIcon = ({ size, outline, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    {outline ? (
      <path
        d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h12v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
        fill={color}
      />
    ) : (
      <path
        d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
        fill={color}
      />
      // <path
      //   id="Path_185"
      //   data-name="Path 185"
      //   d="M21.99,4A2,2,0,0,0,20,2H4A2.006,2.006,0,0,0,2,4V16a2.006,2.006,0,0,0,2,2H18l4,4ZM18,14H6V12H18Zm0-3H6V9H18Zm0-3H6V6H18Z"
      //   transform="translate(-2 -2)"
      //   fill={color}
      // />
    )}
  </svg>
);

export const DocumentIcon2 = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 16 20">
    <path
      id="Path_124"
      data-name="Path 124"
      d="M14,2H6A2,2,0,0,0,4.01,4L4,20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8Zm2,16H8V16h8Zm0-4H8V12h8ZM13,9V3.5L18.5,9Z"
      transform="translate(-4 -2)"
      fill={color}
    />
  </svg>
);

export const ExclamationIcon = ({ size, color = "red" }) => (
    <svg width={size} height={size} fill={color} viewBox="0 0 16 16">
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
  </svg>
);

export const HelpIcon = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 22 18"
  >
    <path
      id="Path_128"
      data-name="Path 128"
      d="M21,3H3A1.993,1.993,0,0,0,1,5V17a2,2,0,0,0,2,2H8v2h8V19h5a2,2,0,0,0,1.99-2L23,5A2,2,0,0,0,21,3Zm0,14H3V5H21Zm-5-6L9,15V7Z"
      transform="translate(-1 -3)"
      fill="#fff"
    />
  </svg>
);

export const PeopleIcon = ({ size, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
      fill={color}
    ></path>
  </svg>
);

export const PersonIcon = ({ size, color, title }) => (
  <svg
    focusable="false"
    viewBox="0 0 24 24"
    aria-hidden="true"
    title="ssssssd"
    width={size}
    height={size}
  >
    {title && <title>{title}</title>}
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      fill={color}
    ></path>
  </svg>
);

export const YesNoIcon = ({ conditional, size = "18px", style, title }) => {
  //const sizeNumber = +size.split("px")[0];
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        textAlign: "center",
        alignItems: "center",
        verticalAlign: "bottom",
        display: "inline-flex",
        justifyContent: "center",
        ...style,
      }}
    >
      {conditional ? (
        <Icon
          type="check-filled"
          fill={Color.green()}
          stroke="white"
          width={size}
          mobileWidth={size}
          title={title}
        />
      ) : (
        <Icon
          type="alert-filled"
          fill={Color.red()}
          stroke="white"
          width={size}
          mobileWidth={size}
          title={title}
        />
      )}
    </div>
  );
};

export const GridViewIcon = ({ size, color }) => (
  <svg
    focusable="false"
    viewBox="0 0 300 300"
    title="Listvy"
    width={size}
    height={size}
  >
    <title>Listvy</title>
    <rect width="100" height="100" x="30" y="30" stroke={color} fill="transparent" strokeWidth="20" strokeLinejoin="round"/>
    <rect width="100" height="100" x="170" y="30" stroke={color} fill="transparent" strokeWidth="20" strokeLinejoin="round"/>
    <rect width="100" height="100" x="30" y="170" stroke={color} fill="transparent" strokeWidth="20" strokeLinejoin="round"/>
    <rect width="100" height="100" x="170" y="170" stroke={color} fill="transparent" strokeWidth="20" strokeLinejoin="round"/>
  </svg>
);

export const ListViewIcon = ({ size, color }) => (
  <svg
    focusable="false"
    viewBox="0 0 300 300"
    title="Rutnätsvy"
    width={size}
    height={size}
  >
    <title>Rutnätsvy</title>
    <rect width="240" height="50" x="30" y="30" stroke={color} fill="transparent" strokeWidth="20" strokeLinejoin="round"/>
    <rect width="240" height="50" x="30" y="120" stroke={color} fill="transparent" strokeWidth="20" strokeLinejoin="round"/>
    <rect width="240" height="50" x="30" y="220" stroke={color} fill="transparent" strokeWidth="20" strokeLinejoin="round"/>
  </svg>
);